import { render, staticRenderFns } from "./CustomerImportLocationDropdown.vue?vue&type=template&id=05cd945a&scoped=true"
import script from "./CustomerImportLocationDropdown.vue?vue&type=script&lang=js"
export * from "./CustomerImportLocationDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd945a",
  null
  
)

export default component.exports